import { AxiosError } from 'axios';
import { useState } from 'react';
import {
  ErrorHttpResponse,
  HttpConfig,
  PaginatedResponse,
} from '../../../models/https';
import { pendingJobApplicationsActions } from '../../../redux/slices/pendingJobApplicationsSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

interface PendingApplicationsFilter {
  page?: string;
  perPage?: string;
}

const useGetPendingApplications = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onGetPendingApplicationsError = (
    err: AxiosError<ErrorHttpResponse>
  ) => {
    console.error(
      err?.message ??
        'Something went wrong while fetching pending job applications'
    );
  };

  const getPendingApplications = (filter?: PendingApplicationsFilter) => {
    // Extract pagination values from the filter or use defaults.
    const page = parseInt(filter?.page ?? '1', 10);
    const perPage = parseInt(filter?.perPage ?? '10', 10);

    // Compute offset (0-indexed) from the page number (which is 1-indexed)
    const offset = page - 1;

    // Build the URL using the offset and perPage for pending applications.
    const urlPath = `jobs-service/applications/pending?offset=${offset}&perPage=${perPage}`;
    const url: HttpConfig = {
      url: urlPath,
      method: 'get',
    };

    const onGetPendingApplicationsSuccess = (response: PaginatedResponse) => {
      const {
        numberOfElements,
        totalElements,
        first,
        last,
        totalPages,
        content,
      } = response;
      dispatch(
        pendingJobApplicationsActions.pendingJobApplications({
          numberOfElements,
          totalElements,
          first,
          last,
          totalPages,
          jobData: Array.isArray(content) ? content : [],
        })
      );
    };

    return request(
      url,
      onGetPendingApplicationsSuccess,
      setLoading,
      onGetPendingApplicationsError
    );
  };

  return { getPendingApplications, loading };
};

export default useGetPendingApplications;
